"use client";
import usePost from "@/hooks/usePost";
import { useLoggedIn } from "@/store/useAuthStore";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { LangSetter } from "../TopBar/component/LangSwitch";

const LanguageSwitcher = () => {
  const { auth } = useLoggedIn();
  const { PostMethod } = usePost();
  const pathName = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();

  return (
    <>
      <div className="flex justify-evenly gap-x-3">
        <div
          className="cursor-pointer"
          onClick={() =>
            LangSetter(auth, PostMethod, searchParams, pathName, router, "en")
          }
        >
          <div className="text-base  font-medium relative flex items-center">
            {pathName?.split("/").includes("en") ? (
              <span className="absolute h-2/4 top-1/2 transform -translate-y-1/2 left-0 w-[3px] bg-primary"></span>
            ) : null}
            <p className="inline-block pl-[6px]">English</p>
          </div>
        </div>
        <div
          className="cursor-pointer"
          onClick={() =>
            LangSetter(auth, PostMethod, searchParams, pathName, router, "ar")
          }
        >
          <div className="text-base font-medium relative flex items-center">
            {pathName?.split("/").includes("ar") ? (
              <span className="absolute h-2/4 top-1/2 transform -translate-y-1/2 right-0 w-[3px] bg-primary"></span>
            ) : null}
            <p className="inline-block pr-[6px]"> العربية </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LanguageSwitcher;
